export interface BusSubscription {
  subscribe: (channel: string, lastId: number) => void
  dispose: () => void
}

// One MessageBus subscription: registers at most once, and tears down exactly the handler
// it registered. Subscribing is triggered by async fetches that can resolve after teardown,
// so a subscribe after dispose is a no-op rather than a handler nothing will ever remove.
export function createBusSubscription<P>(
  handler: (payload: P) => void
): BusSubscription {
  let channel: string | null = null
  let disposed = false

  return {
    subscribe(toChannel: string, lastId: number): void {
      if (disposed || channel !== null || !toChannel) return

      window.Silverfin.Polling.subscribe(toChannel, handler, lastId)
      channel = toChannel
    },
    dispose(): void {
      disposed = true
      if (channel === null) return

      window.Silverfin.Polling.unsubscribe(channel, handler)
      channel = null
    },
  }
}
